import React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import styled from "styled-components";

import Button from "../Button";
import Modal, { ModalTitle } from "../Modal";

// Controlled modal so the landing button can drive open/close — Radix
// owns escape / overlay-click / focus trap; we own the chrome.
function WhatModal({ open, onOpenChange }) {
  return (
    <Modal open={open} onOpenChange={onOpenChange} width={600}>
      <ModalTitle>
        It's Time to <EggsTitle>Build Eggs</EggsTitle>
      </ModalTitle>
      <Body>
        <p>
          Global institutions have dramatically underestimated demand for eggs
          that look like Marc Andreessen. This failure will reverberate through
          the rest of the decade and beyond, but it's not too late to roll up
          our sleeves and start fixing it.
        </p>
        <p>
          We have enemies. Our enemy is inertia. Our enemy is regulatory
          capture. Our enemy is that Googling
          <ModalStrong> "Marc Andreessen Egg"</ModalStrong> barely returns any
          results - a damning failure of the media that is as much a
          generational indictment as it is a call to action.
        </p>
        <p>
          If drawing eggs that look like Marc Andreessen were easy, we'd already
          be doing it. And doing it will take builders of all types: builders
          that use
          <ModalStrong> Speedrun Mode</ModalStrong> to ship 3 eggs at maximum
          velocity, and builders that use
          <ModalStrong> Creative Mode</ModalStrong> to painstakingly produce 1
          egg of generational quality.
        </p>
        <p>
          As you draw eggs, ask yourself:{" "}
          <i>
            "is this egg so good that I want to see it every time Marc posts on
            Twitter?"
          </i>{" "}
          And when the answer is yes, you should contribute to the
          <ModalStrong> Egg Gallery</ModalStrong> - a by-founders-for-founders
          global registry of the best that we all have to offer.
        </p>
        <p>
          <ModalStrong>You're still early.</ModalStrong> Ship the eggs. Save the
          world.
        </p>
      </Body>
      <Footer>
        <Dialog.Close asChild>
          <Button variant="primary" size="medium">
            I'm Ready
          </Button>
        </Dialog.Close>
      </Footer>
    </Modal>
  );
}

const ModalStrong = styled.span`
  color: var(--color-orange-700);
`;

const EggsTitle = styled.span`
  color: var(--color-orange-700);
`;

const Body = styled.div`
  font-size: 1rem;
  line-height: 1.55;
  color: var(--color-text);

  p + p {
    margin-top: 1rem;
    text-wrap: pretty;
  }

  em {
    font-style: italic;
  }

  strong {
    font-weight: 700;
  }
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1.25rem;
`;

export default WhatModal;
